import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';

export const BROWARDTRAINROUTE_LAYER_ID = 'browardTrainRouteLayer';

export const CATEGORY_COLORS = {
  'Train Route': [236, 64, 122],
};

const layerConfig = {
  title: 'Train routes',
};

function BrowardTrainRouteLayer() {
  const dispatch = useDispatch();
  const { browardTrainRouteLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>
    selectSourceById(state, browardTrainRouteLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });

  if (browardTrainRouteLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: BROWARDTRAINROUTE_LAYER_ID,

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: browardTrainRouteLayer.visible,
      opacity: browardTrainRouteLayer.opacity,

      getLineColor: [236, 64, 122],
      lineWidthMinPixels: 2,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: BROWARDTRAINROUTE_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
              title: 'Train Route Details',
              includeColumns: ['Route_Name', 'Route_Description'],
            }),
          };
        }
      },
    });
  }
}

export default BrowardTrainRouteLayer;
